import React from "react";
import styled from "styled-components";

const CheckBoxWrapper = styled.div`
	position: relative;
	width: 44px;
`;
const CheckBoxLabel = styled.label`
	position: absolute;
	top: 0;
	left: 0;
	width: 44px;
	height: 24px;
	border-radius: 15px;
	background: rgba(213, 79, 79, 0.1);
	cursor: pointer;
	&::after {
		content: "";
		display: block;
		border-radius: 50%;
		width: 24px;
		height: 24px;
		background: #d54f4f;
		transition: 0.2s;
	}
`;
const CheckBox = styled.input`
	opacity: 0;
	z-index: 1;
	border-radius: 15px;
	width: 42px;
	&:checked + ${CheckBoxLabel} {
		background: rgba(0, 128, 96, 0.1);
		&::after {
			content: "";
			display: block;
			border-radius: 50%;
			width: 24px;
			height: 24px;
			margin-left: 21px;
			transition: 0.2s;
			background: #008060;
		}
	}
`;
const ToggleButton = ({ onChange, isChecked, name, disabled }) => {
	return (
		<CheckBoxWrapper>
			<CheckBox id={name} type="checkbox" name={name} onChange={onChange} checked={isChecked} value={isChecked} disabled={disabled} />
			<CheckBoxLabel htmlFor={name} />
		</CheckBoxWrapper>
	);
};

export default ToggleButton;
